import { HelloProduct, ISpinImage } from "../types/backend";

const does3dDataExist = (product: HelloProduct) => {
  if (product.display_types) {
    if (typeof product.display_types.enable_3d === "boolean") {
      if (!product.display_types.enable_3d) {
        return false;
      }
    }
  }
  if (product.three_dee_model && product.three_dee_model.glb) {
    return true;
  }
  return false;
};

const doesSpecDataExist = (product: HelloProduct) => {
  if (product.display_types) {
    if (typeof product.display_types.enable_spec === "boolean") {
      if (product.display_types.enable_spec) {
          return true;
      }
    }
  }

  return false;
};

const doesSpinDataExist = (product: HelloProduct) => {
  if (product.display_types) {
    if (typeof product.display_types.enable_spin === "boolean") {
      if (!product.display_types.enable_spin) {
        return false;
      }
    }
  }
  if (product.spin_images && product.spin_images.length > 0) {
    const spin = product.spin_images[0];
    if (spin && spin.image_folder_url) {
      return true;
    }
  }
  return false;
};

const doesArDataExist = (product: HelloProduct) => {
  if (product.display_types) {
    if (typeof product.display_types.enable_ar === "boolean") {
      if (!product.display_types.enable_ar) {
        return false;
      }
    }
  }
  if (product.three_dee_model && product.three_dee_model.glb) {
    return true;
  }
  return false;
};

const getSpinData = (product: HelloProduct): ISpinImage | null => {
  if (product.spin_images) {
    if (product.spin_images.length > 0) {
      return product.spin_images[0];
    }
  }
  return null;
};

const isJson = (item: any) => {
  let value = typeof item !== "string" ? JSON.stringify(item) : item;
  try {
    value = JSON.parse(value);
  } catch (e) {
    return false;
  }

  return typeof value === "object" && value !== null;
};

export {
  does3dDataExist,
  doesSpinDataExist,
  doesArDataExist,
  doesSpecDataExist,
  getSpinData,
  isJson,
};
